<template>
  <div class="risk_tip_w">
    <div class="tip_title font_w_bold fz18">风险提示</div>
    <div class="desc_w c_1A1A1A fz15">
      <div>
        本公告仅供参考，不构成要约或要约邀请。本中心仅进行信息发布，对项目的真实性、完整性、有效性不承担任何法律责任，意向方需自行承担由此产生的法律风险。
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {

    }
  }
}
</script>

<style lang='scss' scoped>
.risk_tip_w {
  display: flex;
  align-items: center;
  padding: 13px 0;
  margin: 10px 0;
  background-color: rgba($color: #3084cf, $alpha: 0.1);
  border-right: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
  .tip_title {
    width: 37px;
    padding: 5px 20px;
    color: #ef9a35;
    border-right: 1px solid #ef9a35;
  }
  p {
    &:first-child {
      margin: 0 0 16px 0;
    }
  }
  .desc_w {
    margin: 0 0 0 20px;
  }
}
</style>
